<script setup lang="ts">
import { provide, ref } from 'vue'

import { COLLAPSE_GROUP } from './collapse'

/** Accordion: at most one `AppCollapse` inside is open (legacy vertical nav groups, wp/shell §4.18). */
const openId = ref<string | null>(null)
provide(COLLAPSE_GROUP, { openId })
</script>

<template>
  <slot />
</template>
